export default __webpack_public_path__ + "static/media/384.611f7f86.png";